

import { LoginForm } from "./UserAuthForm"
import logo from "../../assets/Asset 15@4x.png";

export default function LoginPage() {
  return (
    <div className="w-[100vw]">
      <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <LoginForm />
          </div>
        </div>
      </div>
      <div className="relative hidden bg-black lg:block">
        <img
          src={logo}
          alt="Image"
          className="absolute inset-0  object-cover  dark:grayscale mt-[10vh]"
        />
         <div style={{color:'#f6f5f1', position:'absolute', left: '11vw', top: '55vh', fontSize: '5vw', fontWeight:'bolder'}} className="">
          LIRA Admin
        </div>
      </div>
    </div>
    </div>
    
  )
}
